import { Sun, Moon } from "lucide-react";
import { motion } from "framer-motion";
import { useCalculatorTheme } from "@/contexts/CalculatorThemeContext";

const CalculatorThemeToggle = () => {
  const { isDark, toggleTheme } = useCalculatorTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      className="flex items-center gap-2 px-3 py-2 rounded-lg transition-all duration-300"
      style={{
        background: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
        border: isDark ? "1px solid rgba(251,191,36,0.2)" : "1px solid rgba(30,58,95,0.2)",
      }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      <motion.div
        initial={false}
        animate={{ rotate: isDark ? 0 : 180 }}
        transition={{ duration: 0.3 }}
      >
        {isDark ? (
          <Sun className="h-4 w-4" style={{ color: "hsl(45, 93%, 58%)" }} />
        ) : (
          <Moon className="h-4 w-4" style={{ color: "hsl(222, 35%, 25%)" }} />
        )}
      </motion.div>
      <span
        className="text-sm font-medium"
        style={{ color: isDark ? "rgba(255,255,255,0.7)" : "rgba(30,58,95,0.8)" }}
      >
        {isDark ? "Light" : "Dark"}
      </span>
    </motion.button>
  );
};

export default CalculatorThemeToggle;
